// Libs
import React, { useContext, useEffect, useState } from 'react'
import { Tooltip, Table } from 'antd';
import PerfectScrollbar from 'react-perfect-scrollbar';
import moment from 'moment';

// Own Libs
import * as ui from '@digital/ui';

//Api
import { AnexoDemanda, downloadAnexoDemandaPecaOrcamentaria, downloadAnexoFormularioReqCompra, getAnexosPecaOrcamentaria, validaCentroCusto, validaOiSge } from '@app/api/demanda';
import { baixarTemplateFormularioReqCompra } from '@app/api/template';
import { getAllCentroCustoOptions } from '@app/api/centrocusto';
import { getLotacaoDestinoByCodigo } from '@app/api/lotacaoDestino';

//Files
import QuestionarioContextProvider from '@app/hooks/useQuestionario';
import ModalEnviarValidacaoCapex from '../ModalEnviarValidacaoCapex'
import ModalEnviarValidacaoOpex from '../ModalEnviarValidacaoOpex'
import ModalSelectItemServico from '../ModalSelectItemServico';
import ModalComentariosAnexoFormularioReqCompra from '../ModalComentariosAnexoFormularioReqCompra';
import { UploadComponent } from '@app/components/upload/upload';
import { UploadMultProps } from '@app/components/Upload/uploadMultProps';
import { InputLabel } from '@app/components';
import ModalComentariosCampoDemanda from '../../analise/ModalComentariosCampoDemanda';
import { Visibility } from '@app/components/Visibility';

//Utils
import { hasPermission } from '@app/helpers/permissions';
import { optionsSwitch } from '@app/helpers/optionsSwitch';
import ModalEnviarValidacaoContaResultado from '../ModalEnviarValidacaoContaResultado';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { dateTimeFormat } from '@app/helpers/dateTimeFormats';
import { EStatusDemanda } from '@app/enums/EStatusDemanda';
import { EGuidModalComentario } from '@app/enums/EGuidModalComentario';


function ValidacaoControladoriaDemandaPage() {
    const [timer, setTimer] = useState<number | null>(null);
    const [updateTabela, setUpdateTabela] = useState(false);
    const [preenchendoCentroCusto, setPreenchendoCentroCusto] = useState(false);
    const [preenchendoOrdemInvestimento, setPreenchendoOrdemInvestimento] = useState(false);
    const [preenchendoOrdemManutencao, setPreenchendoOrdemManutencao] = useState(false);
    // const [lotacaoDestinoDisabled, setLotacaoDestinoDisabled] = useState(false);
    const [anexosPecaOrcamentaria, setAnexosPecaOrcamentaria] = useState<AnexoDemanda[]>([]);
    const [updateTabelaAnexosPecaOrcamentaria, setUpdateTabelaAnexosPecaOrcamentaria] = useState(true);
    const [existeComentario, setExisteComentario] = useState(false);

    const {
        statusCodigo,
        demandaData,
        capex,
        opex,
        contaResultado,
        codOrdemInvestimento,
        setCodOrdemInvestimento,
        ordemInvestimento,
        setOrdemInvestimento,
        anexoFormularioReqCompra,
        getAnexoFormularioReqCompra,
        requisicaoAbertaPeloDepPlanejamentoControle,
        setRequisicaoAbertaPeloDepPlanejamentoControle,
        pacote,
        setPacote,
        projeto,
        setProjeto,
        codCentroDeCusto,
        setCodCentroDeCusto,
        centroDeCusto,
        setCentroDeCusto,
        setCodLotacaoDestino,
        setLotacaoDestino,
        ordemManutencao,
        setOrdemManutencao,
    } = useContext(QuestionarioContextProvider);

    useEffect(() => {
        async function fetchData() {
            await getAnexoFormularioReqCompra(demandaData && demandaData.id);
        }
        if (demandaData) {
            fetchData();
        }
    }, [demandaData, updateTabela]);

    const columnsAnexo = [
        {
            title: 'Anexos',
            dataIndex: 'descricaoDocumento',
        },
        {
            title: 'Ações',
            width: '10%',
            render: (index: any, record: any) => (
                <>
                    {(!record.aprovado || record.aprovado === undefined) && (
                        <Tooltip title="Adicionar Arquivo">
                            <UploadComponent
                                id={record.id}
                                nomeIdFormulario={'Id'}
                                enderecoApi={'anexoDemanda/UploadAnexoFormularioReqCompra'}
                                idDoComponente={record.id}
                                iconName="messaging-attach"
                                retorno={async data => {
                                    if (data.valid) {
                                        setUpdateTabela(!updateTabela);
                                    }
                                }}
                                hasFile={record.local}
                            />
                        </Tooltip>
                    )}

                    {record.local && (
                        <>
                            <Tooltip title="Baixar Arquivo">
                                <ui.Button
                                    style={{ marginLeft: '10px' }}
                                    icon="ui-download"
                                    type="link"
                                    onClick={() => {
                                        downloadAnexoFormularioReqCompra(record.id, record.nome);
                                    }}
                                />
                            </Tooltip>
                        </>
                    )}

                    <Tooltip title="Download Template">
                        <ui.Button icon="business-new_resume_template" onClick={() => baixarTemplateFormularioReqCompra()} />
                    </Tooltip>
                </>
            ),
        },
        {
            title: 'Comentários',
            dataIndex: 'historicoComentariosAnexoDemanda',
            width: '5%',
            className: 'td-centralizado',
            render: (index: any, record: any) => {
                return (
                    <Tooltip title="Comentários">
                        <ModalComentariosAnexoFormularioReqCompra
                            preSuprimentos={false}
                            anexoId={record.id}
                            contemComentario={record.contemComentarios}
                        />
                    </Tooltip>
                );
            },
        },
        {
            title: 'Status',
            width: '5%',
            render: (index: any, record: any) =>
                record.aprovado !== undefined ? (record.aprovado ? 'Validado' : 'Devolvido') : 'Pendente',
        },
    ];

    const columnsAnexoPecaOrcamentaria = () => {
        const columns: ui.ColumnProps<any>[] = [];

        columns.push({ title: 'Nome', dataIndex: 'nome' });

        columns.push({
            title: 'Inclusão',
            dataIndex: 'dataInclusao',
            width: '15%',
            render: (text, record) => moment(record.dataInclusao).format(dateTimeFormat),
        });

        columns.push({
            title: 'ações',
            dataIndex: 'acoes',
            width: '10%',
            render: (text, record) => (
                <>
                    <UploadMultProps
                        idDoComponente={`mrn-button-ValidacaoControladoriaDemandaPage-upload-substituir-${record.id}`}
                        tooltip={'Substituir Arquivo'}
                        enderecoApi={`anexoDemanda/PecaOrcamentaria/upload`}
                        listUploadPropsForm={[{ key: 'anexoId', value: record.id }]}
                        showLabel={false}
                        retorno={() => {
                            onUpdateAnexosPecaOrcamentaria();
                        }}
                    />

                    <ui.Button
                        icon="ui-download"
                        type="link"
                        onClick={() => {
                            downloadAnexoDemandaPecaOrcamentaria(record.id, record.nome);
                        }}
                        id={`mrn-anexo-peca-orcamentaria-download-${record.id}`}
                    />
                </>
            ),
        });

        return columns;
    };

    const reloadAnexosPecaOrcamentaria = () => {
        if (demandaData && demandaData.id) {
            getAnexosPecaOrcamentaria(demandaData.id).then((response: any) => {
                setAnexosPecaOrcamentaria(response);
            });
        }
    };

    useEffect(() => {
        reloadAnexosPecaOrcamentaria();
    }, [updateTabelaAnexosPecaOrcamentaria]);

    const onUpdateAnexosPecaOrcamentaria = () => {
        setUpdateTabelaAnexosPecaOrcamentaria(!updateTabelaAnexosPecaOrcamentaria);
    };

    const validaOI = (oi: string) => {
        validaOiSge(oi).then((data) => {
            if (data && isObjNotEmpty(data)) {
                if (data.nome) setOrdemInvestimento(data.nome);
                else setOrdemInvestimento('');
                if (data.codigoPacote) setPacote(data.codigoPacote);
                if (data.projeto) setProjeto(data.projeto);
                setCodCentroDeCusto(data.centroCusto);
                validaCC(data.centroCusto);
            } else {
                setOrdemInvestimento('');
                setPacote('');
                setProjeto('');
                ui.notification.error("Ordem de Investimento não encontrada");
            }
        });
    };

    const validaCC = (cc: string) => {
        validaCentroCusto(cc).then(data => {
            if (data) {
                if (data.descricao) {
                    setCentroDeCusto(data.descricao);
                }
            }
        });
    };

    const onChangeCentroCusto = (change: string) => {
        setCodCentroDeCusto(change);
        if (change && change.length > 0) {
            setPreenchendoCentroCusto(true);
            getLotacaoDestinoByCodigo(change).then(lotacaoDestino => {
                if (lotacaoDestino) {
                    setCodLotacaoDestino(lotacaoDestino.codigo);
                    setLotacaoDestino(lotacaoDestino.centroCusto);
                    // setLotacaoDestinoDisabled(true);
                } else {
                    // setLotacaoDestinoDisabled(false);
                    setLotacaoDestino('');
                    setCodLotacaoDestino(undefined);
                }
            });
        } else {
            setPreenchendoCentroCusto(false);
            setCentroDeCusto('');
        }

        if (timer) {
            clearTimeout(timer);
            setTimer(null);
        }
        setTimer(
            setTimeout(() => {
                setCodCentroDeCusto(change);
                if (change && change.length > 0) validaCC(change);
            }, 1000),
        );
    };

    const onChangeOrdemInvestimento = (change: string) => {
        setCodOrdemInvestimento(change);
        if (change.length > 0) setPreenchendoOrdemInvestimento(true);
        else {
            setPreenchendoOrdemInvestimento(false);
            setOrdemInvestimento('');
            setCentroDeCusto('');
            setCodCentroDeCusto('');
        }

        if (timer) {
            clearTimeout(timer);
            setTimer(null);
        }
        setTimer(
            setTimeout(() => {
                setCodOrdemInvestimento(change);
                if (change.length > 0) validaOI(change);
            }, 1000),
        );
    };

    const onChangeOrdemManutencao = (change: string) => {
        setOrdemManutencao(change);
        if (change.length > 0) setPreenchendoOrdemManutencao(true);
        else setPreenchendoOrdemManutencao(false);

        if (timer) {
            clearTimeout(timer);
            setTimer(null);
        }
        setTimer(
            setTimeout(() => {
                setCodCentroDeCusto(demandaData.codCentroCustoDemandante);
                setCentroDeCusto(demandaData.centroCustoDemandante);
                setOrdemManutencao(change);
            }, 1000),
        );
    };

    if (!demandaData) {
        return (<></>);
    }

    const disableFields = 
        [
            EStatusDemanda.AguardandoPreenchimentoDemandante,
            EStatusDemanda.AguardandoRCDemandanteModificacao,
            EStatusDemanda.AguardandoRCReabertura
        ].includes(statusCodigo||0) === false;
    const renderDadosValidacao = () => (
        <Visibility
            visible={[
                EStatusDemanda.AguardandoAnaliseControleFinanceiro,
                EStatusDemanda.AguardandoAnaliseControleFinanceiroModificacao,
                EStatusDemanda.AguardandoAnaliseControleFinanceiroReavaliacao,
                EStatusDemanda.AguardandoAnaliseControladoria,
                EStatusDemanda.AguardandoAnaliseControladoriaModificacao,
                EStatusDemanda.AguardandoAnaliseControladoriaReavaliacao,
            ].includes(statusCodigo || 0) === false}
        >
            <ModalEnviarValidacaoContaResultado />
            <ModalEnviarValidacaoCapex />
            <ModalEnviarValidacaoOpex />

            {capex && (
                <fieldset>
                    <legend>Validação Econômica</legend>
                    <ui.Row className={'label-overflow'}>
                        <ModalSelectItemServico
                            disabled={disableFields}
                        />
                    </ui.Row>

                    <ui.Row className={'label-overflow'}>
                        <ui.FormInput
                            id='mrn-input-codOrdemInvestimento'
                            label="Ordem Investimento"
                            name="codOrdemInvestimento"
                            value={codOrdemInvestimento}
                            span={3}
                            onChange={e => {
                                onChangeOrdemInvestimento(e.currentTarget.value);
                            }}
                            disabled={disableFields}
                        />
                        <ui.FormInput
                            id='mrn-input-view-ordemInvestimento'
                            label=" "
                            name="ordemInvestimento"
                            span={5}
                            value={ordemInvestimento}
                            required={ordemInvestimento === undefined || ordemInvestimento.length === 0}
                            disabled
                        />
                        <ui.FormSelect
                            id='mrn-select-requisicaoAbertaPeloDepPlanejamentoControle'
                            options={optionsSwitch}
                            label="A Requisição será aberta pelo Dep. De Planejamento e Controle?"
                            name="requisicaoAbertaPeloDepPlanejamentoControle"
                            value={requisicaoAbertaPeloDepPlanejamentoControle}
                            onChange={e => setRequisicaoAbertaPeloDepPlanejamentoControle(e)}
                            span={4}
                            required
                            disabled={disableFields}
                        />
                    </ui.Row>

                    <ui.Row>
                        <ui.FormInput id="mrn-input-pacote" name="pacote" label="Pacote" value={pacote} span={3} disabled />
                        <ui.FormInput id="mrn-input-projeto" name="projeto" label="Projeto" value={projeto} span={5} disabled />
                    </ui.Row>

                    <ui.Row style={{ paddingTop: '20px', paddingBottom: '10px', paddingLeft: '10px', paddingRight: '5px' }}>
                        <ui.Table
                            id="mrn-table-requisicaoAbertaPeloDepPlanejamentoControle"
                            columns={columnsAnexo}
                            dataSource={anexoFormularioReqCompra} />
                    </ui.Row>

                </fieldset>
            )}

            {contaResultado && (
                <fieldset>
                    <legend>Validação Econômica</legend>
                    <ui.Row className={'label-overflow'}>
                        <ModalSelectItemServico
                            disabled={disableFields}
                        />
                    </ui.Row>

                    <ui.Row className={'label-overflow'}>
                        <ui.FormSelect
                            label="Centro de Custo"
                            name="codCentroDeCusto"
                            id='mrn-select-codCentroDeCusto'
                            span={3}
                            value={codCentroDeCusto}
                            getOptions={getAllCentroCustoOptions}
                            showSearch
                            allowClear
                            onChange={e => {
                                onChangeCentroCusto(e);
                            }}
                            disabled={
                                preenchendoOrdemInvestimento
                                || preenchendoOrdemManutencao
                                || disableFields
                            }
                            required={
                                (ordemManutencao === undefined || ordemManutencao.length === 0) &&
                                (codCentroDeCusto === undefined || codCentroDeCusto.length === 0)
                            }
                        />
                        <ui.FormInput
                            label=" "
                            name="centroDeCusto"
                            id='mrn-input-centroDeCusto'
                            span={5}
                            disabled
                            value={centroDeCusto}
                            required={
                                (centroDeCusto === undefined || centroDeCusto.length === 0) &&
                                (ordemManutencao === undefined || ordemManutencao.length === 0)
                            }
                        />
                        <ui.FormSelect
                            id='mrn-select-requisicaoAbertaPeloDepPlanejamentoControle'
                            options={optionsSwitch}
                            label="A Requisição será aberta pelo Dep. De Planejamento e Controle?"
                            name="requisicaoAbertaPeloDepPlanejamentoControle"
                            value={requisicaoAbertaPeloDepPlanejamentoControle}
                            onChange={e => setRequisicaoAbertaPeloDepPlanejamentoControle(e)}
                            span={4}
                            required
                            disabled={disableFields}
                        />
                    </ui.Row>

                    <ui.Row style={{ paddingTop: '20px', paddingBottom: '10px', paddingLeft: '10px', paddingRight: '5px' }}>
                        <ui.Table
                            id="mrn-table-requisicaoAbertaPeloDepPlanejamentoControle"
                            columns={columnsAnexo}
                            dataSource={anexoFormularioReqCompra} />
                    </ui.Row>
                </fieldset>
            )}

            {opex && (
                <fieldset>
                    <legend>Validação da Controladoria</legend>

                    <ui.Row className={'label-overflow'}>
                        <ModalSelectItemServico
                            disabled={disableFields}
                        />
                    </ui.Row>

                    <ui.Row className={'label-overflow'}>
                        <ui.FormSelect
                            label="Centro de Custo"
                            name="codCentroDeCusto"
                            id='mrn-select-codCentroDeCusto'
                            span={3}
                            value={codCentroDeCusto}
                            getOptions={getAllCentroCustoOptions}
                            showSearch
                            allowClear
                            onChange={e => {
                                onChangeCentroCusto(e);
                            }}
                            disabled={
                                preenchendoOrdemInvestimento
                                || preenchendoOrdemManutencao
                                || disableFields
                            }
                            required={
                                (ordemManutencao === undefined || ordemManutencao.length === 0) &&
                                (codCentroDeCusto === undefined || codCentroDeCusto.length === 0)
                            }
                        />
                        <ui.FormInput
                            label=" "
                            name="centroDeCusto"
                            id='mrn-input-centroDeCusto'
                            span={5}
                            disabled
                            value={centroDeCusto}
                            required={
                                (centroDeCusto === undefined || centroDeCusto.length === 0) &&
                                (ordemManutencao === undefined || ordemManutencao.length === 0)
                            }
                        />
                    </ui.Row>

                    <ui.Row>
                        <ui.FormInput
                            label="Ordem de Manutenção"
                            name="ordemManutencao"
                            id='mrn-input-ordemManutencao'
                            span={8}
                            value={ordemManutencao}
                            onChange={e => {
                                onChangeOrdemManutencao(e.currentTarget.value);
                            }}
                            disabled={
                                isObjNotEmpty(centroDeCusto)
                                || preenchendoCentroCusto
                                || preenchendoOrdemInvestimento
                                || disableFields
                            }
                        />
                    </ui.Row>

                    <ui.Row>
                        <Visibility
                            visible={existeComentario}
                        >
                            <ui.FormSelect
                                id='mrn-select-temPrevisaoOrcamentaria'
                                options={optionsSwitch}
                                label="Está previsto na peça Orçamentária?"
                                name="temPrevisaoOrcamentaria"
                                span={4}
                                disabled
                            />
                        </Visibility>

                        <InputLabel
                            label={''}
                            span={4}
                        >
                            <ModalComentariosCampoDemanda
                                idDoComponente='mrn-modal-ModalComentariosCampoDemanda'
                                campoId={EGuidModalComentario.ESCLARECIMENTO_PREVISAO_ORCAMENTARIA}
                                demandaId={demandaData.id}
                                preSuprimentos={true}
                                key={demandaData.id}
                                ehTelaDemandante={true}
                                existeComentario={(existe) => {
                                    setExisteComentario(existe);
                                }}
                            />
                        </InputLabel>
                    </ui.Row>

                    <Visibility
                        visible={existeComentario}
                    >
                        <ui.Row style={{ float: 'right', paddingBottom: '16px' }}>
                            <UploadMultProps
                                idDoComponente='mrn-button-ValidacaoControladoriaDemandaPage-upload-incluir'
                                tooltip={'Incluir Arquivo'}
                                listUploadPropsForm={[
                                    { key: 'demandaId', value: demandaData.id },
                                ]}
                                enderecoApi={`anexoDemanda/PecaOrcamentaria/upload`}
                                iconName={'ui-upload'}
                                hasFile={false}
                                label="INCLUIR ANEXO"
                                buttonClass="ant-btn-primary"
                                retorno={() => {
                                    onUpdateAnexosPecaOrcamentaria();
                                }}
                            />
                        </ui.Row>
                        <PerfectScrollbar className='width-100'>
                            <Table
                                rowKey="id"
                                columns={columnsAnexoPecaOrcamentaria()}
                                dataSource={anexosPecaOrcamentaria}
                                pagination={false}
                            />
                        </PerfectScrollbar>
                    </Visibility>


                </fieldset>
            )}
        </Visibility>
    )

    return (
        <>
            <Visibility
                visible={[
                    EStatusDemanda.AguardandoAnaliseControleFinanceiro,
                    EStatusDemanda.AguardandoAnaliseControleFinanceiroModificacao,
                    EStatusDemanda.AguardandoAnaliseControleFinanceiroReavaliacao,
                ].includes(statusCodigo || 0)}
            >
                <div style={{ textAlign: 'center' }}>
                    <h3
                        style={{ color: 'rgb(105,105,105' }}
                        id="mrn-label-aguardandoAnaliseControleFinanceiro"
                    >
                        Sua demanda será validada pelo Departamento de Planejamento e Controle Econômico.
                    </h3>
                </div>
            </Visibility>

            <Visibility
                visible={[
                    EStatusDemanda.AguardandoAnaliseControladoria,
                    EStatusDemanda.AguardandoAnaliseControladoriaModificacao,
                    EStatusDemanda.AguardandoAnaliseControladoriaReavaliacao,
                ].includes(statusCodigo || 0)}
            >
                <div style={{ textAlign: 'center' }}>
                    <h3
                        style={{ color: 'rgb(105,105,105' }}
                        id="mrn-label-aguardandoAnaliseControladoria"
                    >
                        Sua demanda será validada pela Controladoria – Departamento de Planejamento e Controle Econômico.
                    </h3>
                </div>
            </Visibility>


            {renderDadosValidacao()}
        </>
    )
}

export default ValidacaoControladoriaDemandaPage